import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraEyebrow } from '../ensigns/eyebrow';
import { SpecraHeading, SpecraText } from '../ensigns/typography';
/** Standard content header with the restrained title hierarchy used by Delivery. */ export function SpecraPageHeader({ actions, className, description, eyebrow, meta, title, titleSize = 'ui', ...props }) {
    return /*#__PURE__*/ _jsxs("header", {
        className: cn('flex flex-col items-stretch gap-4 sm:flex-row sm:flex-wrap sm:items-end', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    eyebrow ? /*#__PURE__*/ _jsx(SpecraEyebrow, {
                        className: "mb-2",
                        children: eyebrow
                    }) : null,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-wrap items-baseline gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraHeading, {
                                as: "h1",
                                size: titleSize,
                                children: title
                            }),
                            meta !== undefined && meta !== null && meta !== false && meta !== '' ? /*#__PURE__*/ _jsx(SpecraText, {
                                as: "div",
                                size: "caption",
                                tone: "muted",
                                children: meta
                            }) : null
                        ]
                    }),
                    description ? /*#__PURE__*/ _jsx(SpecraText, {
                        as: "div",
                        className: "mt-[var(--space-ui-gap)] max-w-3xl",
                        tone: "muted",
                        children: description
                    }) : null
                ]
            }),
            actions ? /*#__PURE__*/ _jsx("div", {
                className: "flex w-full flex-wrap items-center gap-2 sm:w-auto sm:shrink-0",
                children: actions
            }) : null
        ]
    });
}
